<!-- Breadcrumb reference -->
<cec-breadcrumb [isVisible]="isOrganizer()"></cec-breadcrumb>

<!-- Stage results table reference -->
<cec-grid
  [id]="stageId"
  [dataSource]="service"
  [hideColumns]="!isOrganizer()"
  (onButtonClicked)="onButtonClick($event)"
>
  <cec-toolbar (onButtonClicked)="onToolbarClick($event)">
    <cec-toolbar-item
      id="add"
      type="menu"
      icon="add"
      [tooltip]="'Add' | translate"
      [visible]="isOrganizer()"
    >
      <cec-toolbar-item
        id="radar"
        type="button"
        icon="videocam"
        [tooltip]="'Add radar' | translate"
        [visible]="isOrganizer()"
      >
      </cec-toolbar-item>
      <cec-toolbar-item
        id="driving-report"
        type="button"
        icon="assignment"
        [tooltip]="'Add driving report' | translate"
        [visible]="isOrganizer()"
      >
      </cec-toolbar-item>
      <cec-toolbar-item
        id="speed-trial"
        type="button"
        icon="directions_car"
        [tooltip]="'Add speed trial' | translate"
        [visible]="isOrganizer()"
      >
      </cec-toolbar-item>
    </cec-toolbar-item>
    <cec-toolbar-item
      id="recalculate"
      icon="calculate"
      [tooltip]="'Recalculate results' | translate"
      [visible]="isOrganizer()"
    >
    </cec-toolbar-item>
    <cec-toolbar-item
      id="visibility"
      [icon]="!display() ? 'visibility' : 'visibility_off'"
      [tooltip]="(!display() ? 'Display results' : 'Hide results') | translate"
      [visible]="isOrganizer()"
    >
    </cec-toolbar-item>
    <cec-toolbar-item
        id="speed-trials"
        type="button"
        icon="directions_car"
        [tooltip]="'Navigate to speed trial results' | translate"
        [visible]="isOrganizer()"
      >
    </cec-toolbar-item>
    <cec-toolbar-item
      id="driving-reports"
      icon="assignment"
      [tooltip]="'Navigate to driving reports' | translate"
      [visible]="isOrganizer()"
    >
    </cec-toolbar-item>
    <cec-toolbar-item
      id="print"
      [icon]="'print'"
      [tooltip]="'PrintResults' | translate"
      [visible]="isOrganizer()"
    >
    </cec-toolbar-item>
  </cec-toolbar>
</cec-grid>

<!-- Speed trial dialog reference -->
<cec-speed-trial-result-dialog (reload)="reload()"></cec-speed-trial-result-dialog>

<!-- Radar dialog reference -->
<cec-radar-dialog (reload)="reload()"></cec-radar-dialog>

<!-- Speed trial summary reference -->
@if (speedTrial) {
  <cec-dialog width="22rem" headerKey="Speed trial result" [subTitle]="speedTrial.crewNumber" [hideConfirmButton]="true">
      <cec-result-summary>
        <cec-result-item labelKey="Time" [value]="speedTrial.time"></cec-result-item>
        <cec-result-item labelKey="TimePoints" [value]="speedTrial.timePoints"></cec-result-item>
        <cec-result-item labelKey="ElementPoints" [value]="speedTrial.points"></cec-result-item>
        <cec-result-item labelKey="Total summary" [value]="speedTrial.totalPoints" type="total"></cec-result-item>
      </cec-result-summary>
  </cec-dialog>
}

<!-- Crew detail dialog reference -->
<cec-crew-detail-dialog></cec-crew-detail-dialog>